<div class="uk-container">
  <div class="sidebar-network-status">
    <app-network-status></app-network-status>
  </div>

  <div class="activa-logo">
    <img src="./assets/img/static/svg-activa.svg" alt="Activa logo" />
  </div>

  <nav class="sidebar-nav">
    <!-- Gestion des adhésions -->
    <div class="menu">
      <button (click)="openProducerPolicyManagementPage()" [class.active]="isActive('producteur-policy-management')"
        class="uk-width-1-1">
        <img class="sidebar-icon" src="assets/img/static/assistance.svg" width="24" height="24"
          style="width:24px;height:24px;" uk-svg="stroke-animation: true" />
        <span>Gestion des adhésions</span>
      </button>
    </div>

    <!-- Commissions -->
    <div class="menu">
      <button (click)="openProducerCommissionsPage()" [class.active]="isActive('producteur-commissions')"
        class="uk-width-1-1">
        <img class="sidebar-icon" src="assets/img/static/receipt.svg" width="24" height="24"
          style="width:24px;height:24px;" uk-svg="stroke-animation: true" />
        <span>Commissions</span>
      </button>
    </div>

    <!-- Listing des sinistres -->
    <div class="menu">
      <button (click)="openProducerSinistreListPage()" [class.active]="isActive('producer-claim-historic')"
        class="uk-width-1-1">
        <img class="sidebar-icon" src="assets/img/static/assistance.svg" width="24" height="24"
          style="width:24px;height:24px;" uk-svg="stroke-animation: true" />
        <span>Listing des sinistres</span>
      </button>
    </div>

    <!-- Transfert de sinistre -->
    <div class="menu">
      <button (click)="openTransferSinistrePage()" [class.active]="isActive('producteur-transfertsinistre')"
        class="uk-width-1-1">
        <img class="sidebar-icon" src="assets/img/static/transfer.svg" width="24" height="24"
          style="width:24px;height:24px;" uk-svg="stroke-animation: true" />
        <span>Transférer sinistre</span>
      </button>
    </div>

    <!-- Coassurance -->
    <div class="menu">
      <button (click)="openProducerCoassurancePage()" [class.active]="isActive('producteur-coassurance')"
        class="uk-width-1-1">
        <img class="sidebar-icon" src="assets/img/static/receipt.svg" width="24" height="24"
          style="width:24px;height:24px;" uk-svg="stroke-animation: true" />
        <span>Coassurance</span>
      </button>
    </div>
    <div class="menu">
      <button (click)="goToHome()" class="uk-width-1-1">
        <svg class="sidebar-icon" width="24" height="24" viewBox="0 0 24 24" fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <rect x="3" y="3" width="7" height="9" stroke="currentColor" stroke-width="2" fill="none"></rect>
          <rect x="14" y="3" width="7" height="5" stroke="currentColor" stroke-width="2" fill="none"></rect>
          <rect x="14" y="12" width="7" height="9" stroke="currentColor" stroke-width="2" fill="none"></rect>
          <rect x="3" y="13" width="7" height="5" stroke="currentColor" stroke-width="2" fill="none"></rect>
        </svg>
        <span>Dashboard</span>
      </button>
    </div>
  </nav>

  <!-- <div class="home-btn">
    <button (click)="goToHome()">
      Accueil
    </button>
  </div> -->




</div>